export var cifNg = ["301 151", "<g fill='none'><path fill='#008751' d='M.5.5h300v150H.5z'/><path fill='#FFF' d='M100.5.5h100v150h-100z'/></g>"];
